import React from 'react';
import { useStrategy, Strategy } from '../../contexts/StrategyContext';

interface StrategyToggleProps {
  className?: string;
}

/** Covered call / cash-secured put lens. Styled by `.seg` (trader theme). */
const StrategyToggle: React.FC<StrategyToggleProps> = ({ className }) => {
  const { strategy, setStrategy } = useStrategy();

  const options: { value: Strategy; label: string; shortLabel: string }[] = [
    { value: 'cc', label: 'Covered Call', shortLabel: 'CC' },
    { value: 'csp', label: 'Cash Secured Put', shortLabel: 'CSP' },
  ];

  return (
    <div className={`seg strategy-toggle ${className || ''}`} role="group" aria-label="Strategy">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-pressed={strategy === opt.value}
          onClick={() => setStrategy(opt.value)}
          title={opt.label}
        >
          <span className="strategy-toggle-full">{opt.label}</span>
          <span className="strategy-toggle-short">{opt.shortLabel}</span>
        </button>
      ))}
    </div>
  );
};

export default StrategyToggle;
